module.exports = __webpack_public_path__ + "static/media/roof_only_sprite.52a4e579.png";